export default __webpack_public_path__ + "static/media/partner-03.05871465.webp";